import 'reflect-metadata';
import FormContainer from './FormContainer';

export default FormContainer;
